import React from 'react'

export const MobilePiData = () => {
    const [phone, setPhone] = React.useState('')
    const [cardData, setCardData] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const inputvalue = (e) => {
        const value = e.target.value;
        if (value.length > 10) {
            alert('Mobile Number cannot be more than 10 digits');
            return;
        }
        if (/^\d{0,10}$/.test(value)) {
            setPhone(value);
        }
    };


    const handle = () => {
        setLoading(true)
        // alert('Mobile Pi Data Submitted')
        const myHeaders = new Headers();
        myHeaders.append("x-api-key", "9LJepWgWB15Ipz3pJaWdG40Gqe5rJ2Mv1HyhrbkY");
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            "mobile_number": phone,
            "consent": "Y"
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch("https://0yo4ue3vna.execute-api.ap-south-1.amazonaws.com/default/mobile_pi_data", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                setLoading(false)
                console.log(result)
                setCardData(result)
            })
            .catch((error) => {
                console.error(error)
                setLoading(false)
            });
    }

    return (
        <div>
            <p style={{ textAlign: 'center' }}>Mobile Pi Data Component</p>
            {loading ? <p style={{ textAlign: 'center' }}>Loading...</p> : <div style={{ padding: '20px', margin: 'auto' }}>
                <p>Mobile No.</p>
                <input type="text" value={phone} onChange={inputvalue} placeholder='Enter Mobile No.' style={{ width: '10rem', padding: '10px', marginBottom: '20px' }} />
                <button onClick={handle} style={{ marginTop: '20px', padding: '10px 20px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', marginLeft: '5px' }}>Submit</button>
            </div>}
            {cardData && <DocTable data={cardData} />}
        </div>
    )
}


function DocTable({ data }) {
    if (!data || typeof data !== "object") {
        return <p>No data available</p>;
    }

    const formatLabel = (key) =>
        key
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (str) => str.toUpperCase());

    const renderValue = (value) => {
        if (value === null || value === undefined) return "-";

        if (typeof value === "boolean") {
            return value ? "Yes" : "No";
        }

        if (Array.isArray(value)) {
            return value.length ? (
                <ul style={{ margin: 0, paddingLeft: "18px" }}>
                    {value.map((item, i) => (
                        <li key={i}>{renderValue(item)}</li>
                    ))}
                </ul>
            ) : (
                "-"
            );
        }

        if (typeof value === "object") {
            return (
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        background: "#f9fafb",
                    }}
                >
                    <tbody>
                        {Object.entries(value).map(([k, v]) => (
                            <tr key={k}>
                                <th
                                    style={{
                                        textAlign: "left",
                                        padding: "6px",
                                        border: "1px solid #84aaf8ff",
                                        width: "35%",
                                        background: "#f3f4f6",
                                    }}
                                >
                                    {formatLabel(k)}
                                </th>
                                <td
                                    style={{
                                        padding: "6px",
                                        border: "1px solid #c5d4f3ff",
                                    }}
                                >
                                    {renderValue(v)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            );
        }

        return String(value);
    };

    return (
        <table
            style={{
                width: "100%",
                borderCollapse: "collapse",
                border: "1px solid #e5e7eb",
            }}
        >
            <tbody>
                {Object.entries(data).map(([key, value]) => (
                    <tr key={key}>
                        <th
                            style={{
                                textAlign: "left",
                                padding: "8px",
                                border: "1px solid #0035a0ff",
                                width: "30%",
                                background: "#f3f4f6",
                            }}
                        >
                            {formatLabel(key)}
                        </th>
                        <td
                            style={{
                                padding: "8px",
                                border: "1px solid #75a0f6ff",
                            }}
                        >
                            {renderValue(value)}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}